import React from 'react';
import clsx from 'clsx';
import { IconButton, Tooltip } from '@curves/ui-base';

const FloatButton = ({ children, ...props }) => {
    const { className, tip, onClick } = props;

    return (
        <Tooltip title={tip}>
            <IconButton {...props} className={clsx('float-button', className)} onClick={onClick}>
                {children}
            </IconButton>
        </Tooltip>
    );
};

export default FloatButton;
